var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _path, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTechscopeAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 520,
    fill: "#172554"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 130,
    width: 620,
    height: 270,
    rx: 18,
    fill: "#1e40af"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 165,
    width: 350,
    height: 22,
    rx: 11,
    fill: "#bfdbfe"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 215,
    width: 500,
    height: 14,
    rx: 7,
    fill: "#60a5fa"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 250,
    width: 420,
    height: 14,
    rx: 7,
    fill: "#60a5fa"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 305,
    width: 180,
    height: 52,
    rx: 26,
    fill: "#facc15"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 625,
    cy: 315,
    r: 42,
    fill: "#22c55e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m604 315 14 14 28-32",
    fill: "none",
    stroke: "#052e16",
    strokeWidth: 10
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 75,
    fill: "#dbeafe",
    fontFamily: "sans-serif",
    fontSize: 43,
    fontWeight: 700
  }, "TECHSCOPE AI")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 475,
    fill: "#93c5fd",
    fontFamily: "monospace",
    fontSize: 22
  }, "NEWS \u2022 CREDIBILITY \u2022 INSIGHT")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechscopeAi);
export default __webpack_public_path__ + "static/media/techscope-ai.df8e7dd1cf322f10ee4d9ac9f29f79ab.svg";
export { ForwardRef as ReactComponent };